export default __webpack_public_path__ + "static/media/enviro.37573e7e.svg";